import { render } from "./ColorPicker.vue?vue&type=template&id=b24e256e"
import script from "./ColorPicker.vue?vue&type=script&lang=ts"
export * from "./ColorPicker.vue?vue&type=script&lang=ts"
script.render = render

export default script